import { render, staticRenderFns } from "./BannerHighlightLobForm.vue?vue&type=template&id=a60482e6&scoped=true&"
import script from "./BannerHighlightLobForm.vue?vue&type=script&lang=js&"
export * from "./BannerHighlightLobForm.vue?vue&type=script&lang=js&"
import style0 from "./BannerHighlightLobForm.vue?vue&type=style&index=0&id=a60482e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a60482e6",
  null
  
)

export default component.exports